import React from 'react';
import { Modal, Button, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { selectStyle } from '../../../utils/styleUtils';
import { useForm, Controller } from 'react-hook-form'
import Select from 'react-select';
import _ from 'lodash';
import { setNotificationData } from '../../../redux/global/globalReducer';
import { useDispatch } from 'react-redux';

function DriverModal({
  modal,
  setModal,
  toggle,
  userOptions,
  userCreationInformation,
  setUserCreationInformation,
  toggleFormCancelDisplay,
  // isFormEdit,
  // formType,
  // toggleFormDisplay,
  args
}) {
  const dispatch = useDispatch();
  const { register, handleSubmit, setValue, setError, clearErrors, reset, setFocus, control, formState: { errors, isDirty } } = useForm();

  const onUserSelectChange = (e) => {
    setUserCreationInformation(e);
  }

  const openFormAndCloseModal = () => {
    if (userCreationInformation === null) {
      dispatch(
        setNotificationData({
          type: `error`,
          message: `Error!`,
          description: `Please select a user`,
        })
      );

      return
    }
    toggleFormCancelDisplay();
    toggle();
  }

  const resetValue = () => {
    setUserCreationInformation(null);
  }

  return (
    <>
      <Modal isOpen={modal} toggle={toggle} {...args}>
        <ModalHeader toggle={toggle}>Create a Driver</ModalHeader>
        <ModalBody>
          <form className="row form-container justify-content-center align-items-center" id="driver-form" >
            {/* <div className="col-6 col-sm-4 mb-2"></div> */}
            <div className="col-8 col-sm-6 mb-2">
              <label htmlFor="userId" className="form-label">User</label>
              <div className="custom-selector">
                <Controller
                  name="userId"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      onChange={(e) => { field.onChange(e); onUserSelectChange(e) }}
                      value={userCreationInformation}
                      options={userOptions}
                      className="company-select"
                      classnameprefix="react-select"
                      placeholder={'User'}
                      id="user"
                      styles={selectStyle}
                      isclearable="true"
                      tabIndex={11}
                    />
                  )}
                />
              </div>
              <small className='form-error-message'>
                {errors?.companyName && errors.companyName.message}
              </small>
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={openFormAndCloseModal}>
            Create Driver
          </Button>
        </ModalFooter>
      </Modal>
    </>

  )
}

export default DriverModal